import {useCallback, useEffect, useState} from "react";
import {mergeMedicalOrganizations} from "../model/mergeMedicalOrganizations";
import {MedicalOrganizationVaccine} from "../../../types/MedicalOrganizationVaccine";
import {getOrganizationVaccines} from "../../../services/organizationVaccine";
import {getMedicalOrganizations} from "../../../services/medicalOrganization";

export const useMedicalOrganizationVaccines = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [medicalOrganizationVaccines, setMedicalOrganizationVaccines] = useState<MedicalOrganizationVaccine[]>([]);

  const fetchMedicalOrganizations = useCallback(async () => {
    return await getMedicalOrganizations()
  }, [])

  const fetchOrganizationVaccines = useCallback(async () => {
    return await getOrganizationVaccines()
  }, [])


  const fetch = async () => {
    setIsLoading(true);
    setError('');

    try {
      const [medicalOrganizations, organizationVaccines] = await Promise.all([
        fetchMedicalOrganizations(),
        fetchOrganizationVaccines(),
      ]);
      const tempMedicalOrganizationVaccines = mergeMedicalOrganizations(
        medicalOrganizations,
        organizationVaccines
      )
      setMedicalOrganizationVaccines(tempMedicalOrganizationVaccines)
    } catch (error) {
      setError(error?.message || 'Failed to fetch ');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetch();
  }, []);


  return { medicalOrganizationVaccines, isLoading, error }

}